export default __webpack_public_path__ + "static/18-82070f10a99c937102fff1210f9f9de6.png";